import React from 'react';
import { contactItems } from '../../../data/contactItems';
import SectionHeader from '../../common/SectionHeader/SectionHeader';
import Button from '../../common/Button/Button';
import { useNavigate } from 'react-router-dom';
import styles from './ContactSection.module.css';

function ContactSection() {
  const navigate = useNavigate();

  return (
    <section className={`section bg-cream ${styles.outer}`} id="contact" aria-label="Liên hệ">
      <div className="container">
        <div className={styles.wrap}>
          {/* Left column: info */}
          <div className={styles.info}>
            <div className="section-label">Liên hệ</div>
            <h3 className={styles.infoHeading}>
              Bắt đầu hành trình ngôn ngữ của bạn ngay hôm nay
            </h3>
            <p className={styles.infoDesc}>
              Thi thử miễn phí để Annie hiểu rõ trình độ hiện tại, mục tiêu học tập
              và thiết kế lộ trình phù hợp nhất với bạn — hoàn toàn miễn phí.
            </p>
          </div>

          {/* Right column: contact items */}
          <div className={styles.contactCard}>
            {contactItems.map((item) => (
              <div key={item.id} className={styles.item}>
                <div className={styles.itemIcon} aria-hidden="true">{item.icon}</div>
                <div className={styles.itemText}>
                  <strong>{item.label}</strong>
                  {item.id === 'facebook' ? (
                    <a href={item.value} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--rose)', textDecoration: 'none' }}>
                      Annie Hồ
                    </a>
                  ) : item.id === 'zalo' ? (
                    <a href={`tel:${item.value}`} style={{ color: 'var(--ink)', textDecoration: 'none' }}>
                      {item.value}
                    </a>
                  ) : (
                    item.value
                  )}
                </div>
              </div>
            ))}
            <div className={styles.buttonRow}>
              <Button
                variant="blue"
                onClick={() => {
                  navigate('/toeic');
                  window.scrollTo({ top: 0 });
                }}
              >
                Thi thử TOEIC
              </Button>
              <Button
                variant="rose-full"
                onClick={() => {
                  navigate('/jlpt');
                  window.scrollTo({ top: 0 });
                }}
              >
                Thi thử JLPT
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
